import { c as _c } from "react/compiler-runtime";
import { Box, Center, Spinner, VStack } from '@chakra-ui/react';
import { InvestorSearchFilterForm } from '@src/components/sco/InvestorSearch/InvestorSearchFilters';
import { SidebarCollapsingNavList } from '@src/components/sco/SidebarCollpasingNavList';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import React from 'react';
import { LuHeart, LuLightbulb, LuSearch } from 'react-icons/lu';
type InvestorSearchNavProps = {};
export const investorSearchNavItems = [{
  href: '/investors/matching',
  title: 'Investor Matching',
  icon: LuLightbulb
}, {
  href: '/investors/search',
  title: 'Investor Database',
  icon: LuSearch
}, {
  href: '/investors/saved',
  title: 'Saved Investors',
  icon: LuHeart
}].filter(Boolean);
export const InvestorSearchNav = props => {
  const $ = _c(3);
  const {
    currentUser
  } = useCurrentUser();
  if (!currentUser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Center paddingY="10em"><Spinner /></Center>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SidebarCollapsingNavList collapsed={true} defaultIcon={LuSearch} defaultTitle="Investors" items={investorSearchNavItems} />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VStack align="stretch" gap={0} height="full" width="full">{t0}<Box height="full" overflowY="auto"><SSRGate disableSSR={true}><InvestorSearchFilterForm /></SSRGate></Box></VStack>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};